import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-question-categories',
  templateUrl: './question-categories.component.html',
  styleUrls: ['./question-categories.component.scss']
})
export class QuestionCategoriesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
